import { IAutomationEvent } from '@/interfaces/automation_events'

export const automationEvents: IAutomationEvent[] = [
  {
    value: "BalanceUpdated",
    label: "Balance Crossed",
    subtype: "BalanceCrossed",
    filters: { balance_crosses_threshold: { predicate: "crosses_down?" } },
    filter_options: [
      {
        name: "balance_crosses_threshold",
        options: { required: true },
      },
    ],
    name: "Your balance is low",
    message:
      "Hello,\nYour balance crossed the threshold\nKind reminder to add balance in order not to stop activity\nRegards, Traforama",
  },
  {
    value: "BalanceUpdated",
    label: "Balance Added",
    subtype: "BalanceAdded",
    filters: { amount: { predicate: "gt?", value: "0" } },
    name: "Balance was topped up",
    message: "Hello,\nYour balance was topped up\nRegards, Traforama",
  },
  {
    value: "CreativeStatusUpdated",
    label: "Creative has been approved",
    subtype: "CreativeStatusApproved",
    filters: {
      current_state: { predicate: "included_in?", value: "approved" },
    },
    name: "Creative has been approved",
    message:
      "Hello,\nYour creative ID: *|creative_id|* *|creative_name|* has been approved\nRegards, Traforama",
  },
  {
    value: "CreativeStatusUpdated",
    label: "Creative has been rejected",
    subtype: "CreativeStatusRejected",
    filters: {
      current_state: { predicate: "included_in?", value: "rejected" },
    },
    name: "Creative has been rejected",
    message:
      "Hello,\nYour creative ID: *|creative_id|* *|creative_name|* has been rejected\nReason: *|reject_reason|*\nRegards, Traforama",
  },
  {
    value: "CampaignLimitReached",
    label: "Campaign limit has been reached",
    subtype: "CampaignLimitReached",
    filters: {},
    name: "Campaign limit has been reached",
    message:
      "Hello,\nYour campaign ID: *|campaign_id|* *|campaign_name|* has just reached its *|limit_type|* limit of *|limit_value|* which is why you've stopped getting traffic.\nYou're welcome to expand or remove the limit in the campaign settings to resume the campaign.\nRegards, Traforama",
  },
];
